export const LEGEND_MARGIN = 16;
